var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInternet({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1760_25336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.2883 48.6377C56.9706 48.6377 48.5767 57.0318 48.5767 67.3494C49.5174 92.1391 85.0632 92.132 86.0002 67.3493C86 57.0316 77.6059 48.6377 67.2883 48.6377ZM72.8864 72.9475C71.9024 73.9314 70.3072 73.9314 69.3232 72.9475L67.2883 70.9125L65.2533 72.9475C64.2694 73.9314 62.6742 73.9314 61.6902 72.9475C60.7063 71.9635 60.7063 70.3683 61.6902 69.3844L63.7252 67.3494L61.6902 65.3145C60.7063 64.3305 60.7063 62.7353 61.6902 61.7514C62.6742 60.7674 64.2694 60.7674 65.2533 61.7514L67.2883 63.7861L69.3232 61.7512C70.3072 60.7672 71.9024 60.7672 72.8864 61.7512C73.8703 62.7352 73.8703 64.3303 72.8864 65.3143L70.8514 67.3493L72.8864 69.3842C73.8703 70.3683 73.8703 71.9635 72.8864 72.9475ZM48.8426 42.0582C56.606 49.2746 67.3775 38.5199 60.1563 30.7445C48.4719 19.0601 29.5276 19.0601 17.8432 30.7445C14.7189 33.8687 14.7189 38.934 17.8432 42.0582C20.9674 45.1824 26.0326 45.1824 29.1569 42.0582C34.5928 36.6221 43.4065 36.6221 48.8426 42.0582Z",
    fill: "#C05051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3424 26.5584C72.0952 33.7725 82.8815 23.0267 75.656 15.2447C55.4112 -5.00009 22.5879 -5.00009 2.34316 15.2447C-0.781055 18.3689 -0.781055 23.4342 2.34316 26.5584C5.46738 29.6826 10.5326 29.6826 13.6569 26.5584C27.6532 12.5619 50.3459 12.5619 64.3424 26.5584ZM38.9997 43.9012C34.5814 43.9012 30.9996 47.4829 30.9996 51.9012C31.3918 62.5015 46.609 62.4987 46.9995 51.901C46.9995 47.4829 43.4179 43.9012 38.9997 43.9012Z",
    fill: "#C05051"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1760_25336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 86,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no-internet.ad5297c65c481f6466e9a9729ebe96d8.svg";
export { ForwardRef as ReactComponent };